function initObserver() {
  const sections = Array.from(document.querySelectorAll("section"));
  const mapElement = document.getElementById('map');
  let currentDetectedYear = null;
  window.currentIndex = 0;

  // run initial nav visibility if available
  if (typeof updateNavVisibility === 'function') {
    updateNavVisibility();
  }

  // Only initialize map-related functionality if map exists
  if (mapElement) {
    const locationOffsetsDesktop = {
      "World": 0,
      "Tangkrogen": 80,
      "Ådalen": 160,
      "Eskelunden": 240,
      "Outworld": 320
    };
    const locationOffsetsMobile = {
      "World": 0,
      "Tangkrogen": 30,
      "Ådalen": 60,
      "Eskelunden": 90,
      "Outworld": 120
    };

    function getOffsets() {
      return window.innerWidth < 768
        ? locationOffsetsMobile
        : locationOffsetsDesktop;
    }
  }

  const observer = new IntersectionObserver((entries) => {
    // 1) Find the most visible section
    const sorted = entries
      .filter(entry => entry.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
    if (sorted.length === 0) return;

    const entry = sorted[0];

    // 2) Update the global scroll index
    const idx = sections.indexOf(entry.target);
    if (idx !== -1) window.currentIndex = idx;

    // 3) Handle map if present
    if (mapElement) {
      const lat     = parseFloat(entry.target.dataset.lat);
      const lng     = parseFloat(entry.target.dataset.lng);
      const zoom    = parseFloat(entry.target.dataset.zoom);
      const pitch   = parseFloat(entry.target.dataset.pitch || 0);
      const bearing = parseFloat(entry.target.dataset.bearing || 0);
      const speed   = parseFloat(entry.target.dataset.speed || 0.8);

      map.flyTo({
        center: [lng, lat],
        zoom: zoom,
        pitch: pitch,
        bearing: bearing,
        speed: speed,
        curve: 1
      });

      // 4) Move the ribbon
      const offsets = getOffsets();
      const desc    = entry.target.dataset.desc;
      const ribbon  = document.querySelector('.location ul');
      if (desc && ribbon && offsets.hasOwnProperty(desc)) {
        ribbon.style.transform = `translateX(${offsets[desc]}px)`;
      }
    }

    // 5) Intro section
    if (entry.target.classList.contains('intro')) {
      currentDetectedYear = null;
      resetSectionAnimations();
      hideAllEfforts();
      animateIntro();
      return;
    }

    // 6) Outro section
    if (entry.target.classList.contains('outro')) {
      currentDetectedYear = null;
      resetSectionAnimations();
      stackAllEfforts();
      animateOutro();
      return;
    }

    // 7) Regular year sections
    const detectedYear = parseInt(entry.target.dataset.year, 10);
    if (!isNaN(detectedYear) && detectedYear !== currentDetectedYear) {
      currentDetectedYear = detectedYear;
      resetSectionAnimations();
      layoutEffortsByYear(detectedYear);
      
      // Update scroll index again in case things shifted
      const newIdx = sections.indexOf(entry.target);
      if (newIdx !== -1) window.currentIndex = newIdx;

      animateSectionByYear(String(detectedYear));
    }
  }, {
    threshold: 0.5
  });

  // 8) Start observing each section
  sections.forEach(section => observer.observe(section));
}

window.initObserver = initObserver;